import { DossierDetailsContent, DossierDetailsHeader, DossierDetailsPanel } from "@/app/pages/dossier/dossier-details-panel.tsx";
import { useGetStations } from "@/entities/station";
import { getStationOptions } from "@/features/infra/components/utils.ts";
import { useBestelTVVRoutes } from "@/features/tvv/components/regievoerder/bestel-routes-context.ts";
import { GevondenRoutes } from "@/features/tvv/components/regievoerder/route-zoeken/gevonden-routes.tsx";
import { Button, ErrorDisplay, Label, MultiSelect } from "@/shared/components";
import { useMemo, useState } from "react";

type RoutesZoekenViewProps = {
    dossierId: string;
};

export function RoutesZoekenView({ dossierId }: Readonly<RoutesZoekenViewProps>) {
    const { setMode } = useBestelTVVRoutes();

    return (
        <DossierDetailsPanel>
            <DossierDetailsHeader section="Tvv" title="Zoek route" showBackButton onBackClick={() => setMode("selecteren")} />
            <DossierDetailsContent className="space-y-4">
                <RouteZoeken dossierId={dossierId} />
            </DossierDetailsContent>
        </DossierDetailsPanel>
    );
}

export function RouteZoeken({ dossierId }: RoutesZoekenViewProps) {
    const { data: stations, error } = useGetStations();
    const options = useMemo(() => getStationOptions(stations ?? []), [stations]);
    const [selectedStations, setSelectedStations] = useState<string[]>([]);
    const { setMode } = useBestelTVVRoutes();

    return (
        <div className="grid gap-y-4">
            <div>
                <Label htmlFor="route-stations" className="mb-1">
                    Stations
                </Label>
                <MultiSelect
                    data-testid="tvv-route-zoeken"
                    onValueChange={setSelectedStations}
                    value={selectedStations}
                    options={options}
                    aria-label="Selecteer stations"
                    placeholder="Zoek een of meerdere stations"
                    search={{ emptyMessage: "Geen stations gevonden", placeholder: "Zoek station..." }}
                />
                {error && <ErrorDisplay error={error} />}
            </div>
            <ul>
                <GevondenRoutes dossierId={dossierId} stations={selectedStations} />
            </ul>

            <div>
                <Button onClick={() => setMode("selecteren")}>Klaar</Button>
            </div>
        </div>
    );
}
